import React, { useEffect, useState, useContext } from 'react';
import api from '../utils/api'; 
import './styles/Kidola.css';
import AuthContext from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'; 

const TeacherLeaveFormPage = () => {
    const { user } = useContext(AuthContext);
    const [leaveDate, setLeaveDate] = useState('');
    const [reason, setReason] = useState('');
    const [teacher, setTeacher] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        api.post('/teacher/extratime/getTeacher', { data: { username: user.username }})
          .then(response => {
              const teacherData = response.data.data;
              setTeacher(teacherData);
          })
          .catch(error => console.error('Error fetching teacher list:', error));
    }, [user.username]);

    const handleSubmit = () => {

        setErrorMessage('');

        // Validasi input
        if (!leaveDate || !reason) {
            setErrorMessage('Please fill all field!');
            return;
        }

        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }

        const teacherData = {
            leaveDate: leaveDate,
            reason: reason,
            teacher_id: teacher.teacher_id
        };

        const requestBody = { data: { teacherData } };
        console.log('Request Body:', requestBody);
        api.post('/teacher/leave/save', requestBody)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
            })
            .catch(error => {
                console.error('Error adding/updating teacher:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Leave Request</div>
            <h2></h2>
            <div className="form-container">
                <div className="section">
                <h3 className="section-header">Leave Data</h3>
                    <div className="search-container">
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} {/* Tampilkan pesan kesalahan */}
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Teacher Name</label>
                                    </td><td>
                                        <input 
                                            type="text" 
                                            name="teacherName" 
                                            value={teacher.teacher_name ?? ''} 
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Leave Date</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="date" 
                                            name="leave_date" 
                                            value={leaveDate} 
                                            onChange={e => setLeaveDate(e.target.value)} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Reason</label>
                                    </td>
                                    <td>
                                        <textarea
                                            name="reason" 
                                            value={reason} 
                                            onChange={(e) => setReason(e.target.value)}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="search-container">
                        <button onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeacherLeaveFormPage;
